module.exports = __webpack_public_path__ + "static/img/item_c_pineapple.737028a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item_c_pineapple.png
// module id = wYCJ
// module chunks = 1